import React, { FC, useMemo } from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { PostCategoryFragmentFragment, PostsNavQueryQuery } from "@graphqlTypes"

import SubNav, { SubNavItemType } from '../../../../components/SubNav/SubNav'

type PostsNavProps = {
  currentCategorySlug?: PostCategoryFragmentFragment["slug"]
}

const PostsNav: FC<PostsNavProps> = ({ currentCategorySlug }) => {

  const { allContentfulPostCategory: { nodes: allCategories } } = useStaticQuery<PostsNavQueryQuery>(graphql`
    query PostsNavQuery {
      allContentfulPostCategory(
        filter: {
          hideOnBlog: {ne: true}
          slug: {ne: "all"}
        }
        sort: {navPosition: ASC}
      ) {
        nodes {
          title
          slug
          permalink
        }
      }
    }
  `)

  const navItems: SubNavItemType[] = useMemo(() =>
    allCategories
      .map((category) => ({
        link: category.permalink || "",
        slug: category.slug || "",
        title: category.title || "",
      }))
    , [allCategories])

  return (
    <SubNav
      currentItemSlug={currentCategorySlug || ""}
      items={navItems}
    />
  )
}

export default PostsNav
